/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ExploreMenuRequest
 */
export interface ExploreMenuRequest {
  /**
   *
   * @type {string}
   * @memberof ExploreMenuRequest
   */
  sessionId: string
  /**
   * Null is the initial menu state
   * @type {string}
   * @memberof ExploreMenuRequest
   */
  menuId?: string | null
  /**
   *
   * @type {boolean}
   * @memberof ExploreMenuRequest
   */
  showAllConfigMenu: boolean
}

/**
 * Check if a given object implements the ExploreMenuRequest interface.
 */
export function instanceOfExploreMenuRequest(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'sessionId' in value
  isInstance = isInstance && 'showAllConfigMenu' in value

  return isInstance
}

export function ExploreMenuRequestFromJSON(json: any): ExploreMenuRequest {
  return ExploreMenuRequestFromJSONTyped(json, false)
}

export function ExploreMenuRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ExploreMenuRequest {
  if (json === undefined || json === null) {
    return json
  }
  return {
    sessionId: json['session_id'],
    menuId: !exists(json, 'menuId') ? undefined : json['menuId'],
    showAllConfigMenu: json['showAllConfigMenu'],
  }
}

export function ExploreMenuRequestToJSON(
  value?: ExploreMenuRequest | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    session_id: value.sessionId,
    menuId: value.menuId,
    showAllConfigMenu: value.showAllConfigMenu,
  }
}
